export default __webpack_public_path__ + "static/media/learn.8132cec7.png";